// ReauthHandler.jsx (for your refresh_url)
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { createOnboardingLink } from "../apis/apis";

const ReauthHandler = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const createNewLink = async () => {
      try {
        const response = await createOnboardingLink(accountId);
        console.log("New onboarding link response:", response);
        
        window.location.href = response.url;
      } catch (error) {
        console.error("Error creating new link:", error);
        navigate("/error");
      }
    };

    createNewLink();
  }, [accountId, navigate]);

  return <div>Creating new onboarding link...</div>;
};

export default ReauthHandler;
